import { render, staticRenderFns } from "./packageRate.vue?vue&type=template&id=7aeebeae&"
import script from "./packageRate.vue?vue&type=script&lang=js&"
export * from "./packageRate.vue?vue&type=script&lang=js&"
import style0 from "./packageRate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports